import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const ExtendedSearchResultInfo = styled.div`
  padding-bottom: 15px;
  display: flex;
  justify-content: space-between;
  max-width: ${breakpoints.contentWrapLarge};
  @media (max-width: ${breakpoints.bpDesktopPx}) {
    display: block;
  }
`
export default ExtendedSearchResultInfo
